export const SkeletonUsersPage = () => {
  return (
    <div className="w-full pr-[40px] pl-[10px] animate-pulse">
      {/* Back + Title */}
      <div className="flex items-center my-[10px] gap-[10px]">
        <div className="h-[22px] w-[22px] bg-gray-300 rounded-full" />
        <div className="h-[20px] w-[100px] bg-gray-300 rounded" />
      </div>

      {/* Tabs */}
      <div className="h-[40px] flex items-center justify-between bg-white w-full mb-4">
        <div className="w-[50%] h-full bg-gray-200" />
        <div className="w-[50%] h-full bg-gray-200" />
      </div>

      {/* Manage Users Header */}
      <div className="flex my-[20px] items-end justify-between">
        <div className="space-y-2">
          <div className="h-[20px] w-[150px] bg-gray-300 rounded" />
          <div className="h-[16px] w-[200px] bg-gray-200 rounded" />
          <div className="h-[14px] w-[250px] bg-gray-200 rounded" />
        </div>
        <div className="h-[40px] w-[150px] bg-gray-300 rounded-full" />
      </div>

      {/* Action Bar */}
      <div className="h-[70px] w-full bg-white flex items-center justify-between px-[10px] mb-[10px]">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-[40px] w-[120px] bg-gray-200 rounded" />
        ))}
        <div className="h-[40px] w-[200px] bg-gray-200 rounded" />
        <div className="h-[40px] w-[100px] bg-gray-200 rounded" />
      </div>

      {/* Table Header */}
      <div className="h-[44px] px-[10px] w-full bg-gray-100 mb-[10px] flex items-center gap-4">
        {[...Array(7)].map((_, i) => (
          <div key={i} className="h-[16px] w-[10%] bg-gray-300 rounded" />
        ))}
      </div>

      {/* User Rows */}
      <div className="space-y-2">
        {[...Array(10)].map((_, i) => (
          <div key={i} className="h-[40px] w-full bg-gray-200 rounded" />
        ))}
      </div>

      {/* Pagination */}
      <div className="h-[50px] mt-[20px] flex items-center justify-between">
        <div className="flex items-center gap-[10px]">
          <div className="h-[15px] w-[80px] bg-gray-200 rounded" />
          <div className="h-[15px] w-[60px] bg-gray-200 rounded" />
          <div className="h-[15px] w-[40px] bg-gray-200 rounded" />
          <div className="h-[35px] w-[90px] bg-gray-200 rounded" />
        </div>
        <div className="h-[35px] w-[150px] bg-gray-300 rounded" />
      </div>
    </div>
  );
};
